/**
 * Removes all spaces in string
 */
export const skipSpaces = (value: string) => value.replaceAll(/\s/g, '');
